import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseDefault } from '../Parsers/TEDParserDefault';
import { TEDDisplayBankgiroNr } from '../Displayers/TEDDisplayBankgiroNr';

class TEDFormatBankgiroNr implements IFormatter {
  displayer = TEDDisplayBankgiroNr.getInstance();
  parser = TEDParseDefault.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatBankgiroNr };
